import { isEmptyFields } from "../../../helpers/helper"
import { PlusIcon } from "../../../components/Icons/Icons"
import Input from "../../../components/Input/Input"
import Calendar from "../../../components/Calendar/Calendar"
import SelfEnrollmentDebtFields from "./SelfEnrollmentDebtFields"
import ModalComponent from "../../../components/Modal/Modal"

const SelfEnrollmentManualModal = ({
  isFirstModalPage,
  debts,
  isManualMode,
  popupOnRequest = false,
  creditReport,
  errors,
  fields,
  setFields,
  setErrors,
  handleInputChange,
  createCreditReport,
  createDebts,
  initialFieldSet,
  creditReportTypes,
  creditReportStatuses,
}) => {
  return (
    <div>
      <ModalComponent
        modalButtonTitle="Save"
        buttonType="outlined"
        buttonTitleStyle="flex justify-center"
        title={isFirstModalPage ? "Create Report" : "Create Debts"}
        disableCloseFunctionButton={isFirstModalPage}
        functionButton={isFirstModalPage ? () => createCreditReport() : () => createDebts()}
        customScroll={true}
        openedModal={isManualMode && debts.length <= 0}
        hideCloseButtons={popupOnRequest ? false : debts.length <= 0}
        modalWidth="w-[95vw] md:w-auto md:min-w-[680px] max-w-[1000px]"
        disabled={
          isFirstModalPage
            ? isEmptyFields(creditReport?.creditScore) ||
              isEmptyFields(creditReport?.reportDate) ||
              isEmptyFields(creditReport?.fullName)
            : errors?.some((err) => Object.values(err).some(v => v))
        }
        buttonTitle={
          <p className="flex items-center gap-1 whitespace-nowrap">
            <PlusIcon fill="currentColor" />
            <span>Add Credit Line</span>
          </p>
        }
      >
        {isFirstModalPage ? (
          <div className="flex flex-col gap-4">
            <Input
              classes="h-12"
              label="Full Name"
              placeholder=""
              value={creditReport?.fullName || ""}
              onChange={(e) => handleInputChange("fullName", e.target.value)}
            />
            <Calendar
              height="44px"
              label="Report Date"
              placeholder=""
              value={creditReport?.reportDate || ""}
              onChange={(date) => handleInputChange("reportDate", date)}
            />
            <Input
              type="number"
              classes="h-12"
              label="Credit Score"
              placeholder=""
              value={creditReport?.creditScore || ""}
              onChange={(e) => handleInputChange("creditScore", e.target.value?.replace(/[.,]/g, ''))}
            />
          </div>
        ) : (
          <SelfEnrollmentDebtFields
            setFields={setFields}
            fields={fields}
            errors={errors}
            setErrors={setErrors}
            initialFieldSet={initialFieldSet}
            creditReportTypes={creditReportTypes}
            creditReportStatuses={creditReportStatuses}
          />
        )}
      </ModalComponent>
    </div>
  )
}

export default SelfEnrollmentManualModal
